import React from "react";
import { Chip as MuiChip, Avatar } from "@material-ui/core";
import styled, { css } from "styled-components";

const Chip = styled(MuiChip)`
    margin-left: 0.5rem;
`;

const ProgressChip = styled.div`
    && {
        opacity: 0.9;
        display: flex;
        position: relative;
        &:after {
            ${({ value }) => {
                const radius = 16;
                const radiusPx = 16 + "px";
                const hasFlatEnd = value < 0.5;
                return css`
                    background-color: rgba(0, 0, 0, 0.2);
                    border-radius: ${() => {
                        if (hasFlatEnd) {
                            const endRadius = 0;
                            return `${radiusPx} ${endRadius}px ${endRadius}px ${radiusPx}`;
                        }
                        const endRadius = value * (radius + 4) - 4;
                        return `${radiusPx} ${endRadius}px ${endRadius}px ${radiusPx}`;
                    }};
                    content: "";
                    z-index: 1;
                    position: absolute;
                    left: 0;
                    height: 100%;
                    width: ${value * 100}%;
                    min-width: ${value === 0 ? "none" : radiusPx};
                `;
            }};
        }
    }
`;

const SubjectChip = ({
    label = "",
    onClick = () => {},
    value = 2,
    valueType = "default", // sets colours,
    getValueText = val => val * 10
}) => {
    return (
        <Chip
            avatar={<Avatar>{getValueText(value)}</Avatar>}
            label={label}
            onClick={onClick}
            component={ProgressChip}
            clickable={true}
            aria-label={`${label} subject`}
            value={value}
            color={valueType === "user" ? "primary" : "default"}
        />
    );
};

export { SubjectChip };



// WEBPACK FOOTER //
// ./src/components/start/SubjectChip.js